// react imports
import React, {Fragment, useRef, useState} from "react";
import injectSheet from "react-jss";

//material
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';

//icons
import { ReactComponent as ChevronDown } from 'assets/icons/chevron-down.svg';
import { ReactComponent as ChevronUp } from 'assets/icons/chevron-up.svg';

//styles
import styles from './splitbutton_styles';

const SplitButton = (props) => {
    const {handleSave, handlePreview , handleDownload , isProcessing, processingTitle, disableSave, options} = props;
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const [selectedIndex, setSelectedIndex] = useState(-1);

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        if(index === 0 && !handleDownload) {
            handlePreview();
        } else if(index === 0 && handleDownload) {
            handleDownload();
        } else if(index === 1 && handlePreview) {
            handlePreview();
        }
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    return (
        <Fragment>
            <ButtonGroup
                variant="contained"
                ref={anchorRef}
                className={`splitbuttonsection ${props.classes.splitButtonSection} ${disableSave ? 'splitbuttondisabled' : ''}`}
            >
                <Button onClick={handleSave} disabled={disableSave}>Save & Close</Button>
                <Button
                    className={`${disableSave ? 'splitButtonToggle' : ''}`}
                    size="small"
                    aria-controls={open ? 'split-button-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="menu"
                    onClick={handleToggle}
                >
                    <div className={'toggleicons'}>
                        {open ? <ChevronUp className={'toggle-up'}/> :  <ChevronDown className={'toggle-down'}/>}
                    </div>
                </Button>
            </ButtonGroup>
            <Popper
                sx={{
                    zIndex: 1,
                }}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === 'bottom' ? 'center top' : 'center bottom',
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList id="split-button-menu" autoFocusItem>
                                    {options.map((option, index) => (
                                        <MenuItem
                                            key={index.toString()}
                                            selected={index === selectedIndex}
                                            onClick={(event) => handleMenuItemClick(event, index)}
                                        >
                                            {option}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </Fragment>
    );
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SplitButton);


